import { t } from 'i18next';
import { forwardRef } from 'react';

import LabeledInput from './LabeledInput';

const Name = forwardRef(({ labelText, validators, placeHolder, ...restOfProps }, ref) => {
    let nameValidators = [
        {
            rgx: /^[a-zA-Z][a-zA-Z '-]*[a-zA-Z]$/,
            failText: t('Name.EnterNameValid'),
        },
    ];

    if (validators) {
        let defaultValidators = nameValidators.values();
        for (let v1 of defaultValidators) {
            let newValidators = validators.values();
            for (let v2 of newValidators) {
                if (v1.rgx.toString() === v2.rgx.toString()) {
                    v1.failText = v2.failText;
                }
            }
        }
        nameValidators.concat(validators);
        nameValidators = [...new Set(nameValidators)];
    }

    return (
        <LabeledInput
            validators={nameValidators}
            labelText={labelText ? labelText : t('Name.NameLabel')}
            placeholder={placeHolder ? placeHolder : t('Name.EnterName')}
            ref={ref}
            {...restOfProps}
        />
    );
});

Name.displayName = 'Name';

export default Name;
